import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

const DEFAULT_SHIPPING_TIME = {
  min: 3,
  max: 5,
}
export default {
  splash: {
    title: () => i18n.t(i18nKeys.mailingAddress__splash__title),
    description: () => i18n.t(i18nKeys.mailingAddress__splash__description),
    list1: () => i18n.t(i18nKeys.mailingAddress__splash__list1),
    list2: () => i18n.t(i18nKeys.mailingAddress__splash__list2),
    primaryAction: () => i18n.t(i18nKeys.mailingAddress__splash__primaryAction),
    secondaryAction: () =>
      i18n.t(i18nKeys.mailingAddress__splash__secondaryAction),
  },
  address: {
    title: () => i18n.t(i18nKeys.mailingAddress__address__title),
    subTitle1: date => i18n.t(i18nKeys.mailingAddress__address__subtitle1, { date }),
    subTitle2: () => i18n.t(i18nKeys.mailingAddress__address__subtitle2),
    street1: () => i18n.t(i18nKeys.mailingAddress__address__street1),
    street2: () => i18n.t(i18nKeys.mailingAddress__address__street2),
    zipCode: () => i18n.t(i18nKeys.mailingAddress__address__zipCode),
    primaryAction: () =>
      i18n.t(i18nKeys.mailingAddress__address__primaryAction),
    optional: () => i18n.t(i18nKeys.common__optional),
    h1: () => i18n.t(i18nKeys.submitMailingAddress__h1),
    instructionsOne: () =>
      i18n.t(i18nKeys.submitMailingAddress__instructionsOne),
    instructionsTwo: () =>
      i18n.t(i18nKeys.submitMailingAddress__instructionsTwo),
    streetAddress: () => i18n.t(i18nKeys.common__streetAddress),
    city: () => i18n.t(i18nKeys.common__city),
    state: () => i18n.t(i18nKeys.common__state),
    selectState: () => i18n.t(i18nKeys.common__selectState),
    selectProvince: () => i18n.t(i18nKeys.common__selectProvince),
    submitButton: () => i18n.t(i18nKeys.submitMailingAddress__submitButton),
    back: () => i18n.t(i18nKeys.common__back),
  },
  confirmation: {
    title: () => i18n.t(i18nKeys.mailingAddress__confirmation__title),
    list1: {
      title: () => i18n.t(i18nKeys.mailingAddress__confirmation__list1__title),
      subtitle: () => i18n.t(i18nKeys.mailingAddress__confirmation__list1__subtitle),
      item1: () => i18n.t(i18nKeys.mailingAddress__confirmation__list1__item1),
      item2: () => i18n.t(i18nKeys.mailingAddress__confirmation__list1__item2),
    },
    list2: {
      title: () => i18n.t(i18nKeys.mailingAddress__confirmation__list2__title),
      item1: () => i18n.t(i18nKeys.mailingAddress__confirmation__list2__item1),
      item2: () => i18n.t(i18nKeys.mailingAddress__confirmation__list2__item2),
    },
    eta: () =>
      i18n.t(i18nKeys.mailingAddress__confirmation__eta, {
        a: DEFAULT_SHIPPING_TIME.min,
        b: DEFAULT_SHIPPING_TIME.max,
      }),
    primaryDescription: () =>
      i18n.t(i18nKeys.mailingAddress__confirmation__primaryDescription),
    primaryAction: () =>
      i18n.t(i18nKeys.mailingAddress__confirmation__primaryAction),
  },
  welcomeKit: {
    title: () => i18n.t(i18nKeys.mailingAddress__welcomeKit__title),
    description: () => i18n.t(i18nKeys.mailingAddress__welcomeKit__description),
    primaryAction: () =>
      i18n.t(i18nKeys.mailingAddress__welcomeKit__primaryAction),
  },
}
